'use client';

import { USP_TEXT_KEYS } from '@components/FilterPage/VacancyList/VacancyDivider';
import { Box, freddyTheme, Typography } from '@coolblue-development/freddy';
import { Checkmark } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

export const HeaderDivider = () => {
  const { t } = useTranslation('filterPage.uspTexts');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: freddyTheme.spacing[200],
        padding: freddyTheme.spacing[100]
      }}
    >
      <Checkmark color={freddyTheme.color.border.sentimentPositive} />
      <Typography>{t(USP_TEXT_KEYS[0])}</Typography>
    </Box>
  );
};
